import React, { useMemo, useState } from "react";

const ClassDemandTable = ({ classDemand, ga4Connected }) => {
  const [programFilter, setProgramFilter] = useState("All");

  const programs = useMemo(() => {
    const set = new Set((classDemand || []).map((row) => row.program));
    return [...set].sort();
  }, [classDemand]);

  const rows = useMemo(() => {
    const source = classDemand || [];
    if (programFilter === "All") return source;
    return source.filter((row) => row.program === programFilter);
  }, [classDemand, programFilter]);

  return (
    <section className="owner-dashboard__section">
      <div className="owner-dashboard__section-head">
        <h2>Class demand ranking</h2>
        <p>
          Classes sorted by capacity pressure. Waitlisted classes appear first —
          strong candidates for adding sections or capacity.
        </p>
      </div>

      <div className="owner-dashboard__heatmap-controls">
        <label htmlFor="demand-program">Program</label>
        <select
          id="demand-program"
          value={programFilter}
          onChange={(event) => setProgramFilter(event.target.value)}
        >
          <option value="All">All programs</option>
          {programs.map((program) => (
            <option key={program} value={program}>
              {program}
            </option>
          ))}
        </select>
      </div>

      <div className="owner-dashboard__table-wrap">
        <table className="owner-dashboard__table">
          <thead>
            <tr>
              <th scope="col">Class</th>
              <th scope="col">Program</th>
              <th scope="col">Days</th>
              <th scope="col">Time</th>
              <th scope="col">Open spots</th>
              {ga4Connected && <th scope="col">Waitlist clicks</th>}
              {ga4Connected && <th scope="col">Register clicks</th>}
              <th scope="col">Signal</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={ga4Connected ? 8 : 6}>No classes match this filter.</td>
              </tr>
            ) : (
              rows.map((row) => (
                <tr key={row.id}>
                  <td>{row.name}</td>
                  <td>{row.program}</td>
                  <td>{row.days}</td>
                  <td>{row.time}</td>
                  <td>{row.isWaitlist ? "Full / waitlist" : row.openings}</td>
                  {ga4Connected && <td>{row.waitlistClicks ?? "—"}</td>}
                  {ga4Connected && <td>{row.registerClicks ?? "—"}</td>}
                  <td>
                    <span className={`owner-dashboard__signal owner-dashboard__signal--${row.demandSignal}`}>
                      {row.demandSignal === "high"
                        ? "High"
                        : row.demandSignal === "medium"
                          ? "Medium"
                          : "Low"}
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default ClassDemandTable;
